import React, { forwardRef } from 'react';

const Section = forwardRef(({
  title,
  children,
  actions,
  style = {},
  titleStyle = {},
  className,
  optionTitle,
  classNameTitle
}, ref) => (
  <div className={`bg-white px-8 py-4 my-6 relative ${className}`} ref={ref}>
    <div
      className={`flex mb-4 ${actions ? 'justify-between items-center' : ''}`}
      // eslint-disable-next-line no-restricted-syntax
      style={style}
    >

      <div className="inline-flex space-x-2 items-center w-full">
        <h2
          className={`mb-0 text-flexi-text font-bold text-lg uppercase ${classNameTitle}`}
          // eslint-disable-next-line no-restricted-syntax
          style={titleStyle}
        >
          {title}
        </h2>
        {optionTitle}
      </div>
      <div className="flex gap-4">
        {actions}
      </div>
    </div>
    {children}
  </div>
));

Section.displayName = 'Section';

export default Section;
